<template>
  <div
    class="p-2 file-draggable"
    @click="() => $refs.files.click()"
    @dragover.prevent="onDragover"
    @dragleave.prevent="onDragleave"
    @drop.prevent="onDrop"
    draggable
    :class="{ dragover }"
  >
    <otran-file-input ref="files" @change="onChangeFile" />

    <div
      v-if="files.length === 0"
      class="d-flex justiy-content-center align-items-center empty"
      ref="empty"
    >
      <span>{{ placeholder }}</span>
    </div>
    <ul v-else>
      <li v-for="(file, index) in files" :key="index">
        {{ file.name }} ({{ file.size | toFileSizeText }})
      </li>
    </ul>
  </div>
</template>

<script>
import OtranFileInput from './OtranFileInput.vue'
export default {
  components: { OtranFileInput },
  props: {
    accept: {
      type: Array,
      default: () => ['.doc', '.docx', '.txt', '.hwp', '.pdf'],
    },
    placeholder: {
      type: String,
      default: 'Drag & Drop Here\nor Click to Select',
    },
  },
  data: () => ({
    dragover: false,
    files: [],
  }),
  methods: {
    stageFiles(files = []) {
      for (const file of files) {
        if (this.accept.find(ext => file.name.toLowerCase().endsWith(ext))) {
          this.files.push(file)
        }
      }
      this.$emit('input', this.files)
    },
    onDragover() {
      this.dragover = true
    },
    onDragleave() {
      this.dragover = false
    },
    onDrop(e) {
      this.dragover = false
      this.stageFiles(e.dataTransfer?.files)
    },
    onChangeFile(files) {
      this.stageFiles(files)
    },
    clear() {
      this.files = []
      this.$emit('input', this.files)
    },
  },
  filters: {
    toFileSizeText(size) {
      return `${size} bytes`
    },
  },
}
</script>

<style lang="scss" scoped>
.file-draggable {
  .empty {
    width: 100%;
    height: 100%;
    span {
      width: 100%;
      text-align: center;
      white-space: pre-line;
    }
  }
  width: 100%;
  height: 100%;
  border: 2px dashed gray;
  background-color: #efefef;
  overflow-y: scroll;
  &.dragover {
    border: 4px dashed black;
  }
}
</style>
